export default __webpack_public_path__ + "static/media/blog3.59e9fef0.jpg";